import { BugDebug20Px, GridDesign20Px, Warning20Px } from "@qubit/autoparts";

export const numberOfCompartmentsToBinTypeMap = {
  1: "whole",
  2: "half",
  4: "quarter"
} as const;

export type NumberOfCompartmentsType =
  keyof typeof numberOfCompartmentsToBinTypeMap;

export const flaggedReasons = ["dirty", "damaged", "misconfigured"] as const;
export type FlaggedReasonType = (typeof flaggedReasons)[number];

export const flaggedReasonIconMap: Record<
  FlaggedReasonType,
  React.FC<React.SVGProps<SVGSVGElement>>
> = {
  dirty: BugDebug20Px,
  damaged: Warning20Px,
  misconfigured: GridDesign20Px
};
